module.exports = __webpack_public_path__ + "static/media/sort-amount-up-solid.8b33d58f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sort-amount-up-solid.svg
// module id = 900
// module chunks = 33